import IHttpClientGetParameters from '@/modules/common/contracts/http-client/http-client-get-parameters.interface'
import IHttpClientPostParameters from '@/modules/common/contracts/http-client/http-client-post-parameters.interface'
import HttpClient from '@/modules/common/services/http-client.service'
import Container from 'typedi'

export default class RemoteSupportService {
  public async getRemoteSupport (event_uuid: string) {
    const httpParams: IHttpClientGetParameters = {
      url: `/event/${event_uuid}/remote-support`,
      requireToken: true
    }
    return await Container.get(HttpClient).get(httpParams)
  }

  public async updateRemoteSupport (event_uuid: string, enabled: boolean) {
    const httpParams: IHttpClientPostParameters = {
      url: `/event/${event_uuid}/remote-support`,
      requireToken: true,
      payload: { enabled }
    }
    return await Container.get(HttpClient).post(httpParams)
  }
}
